import covers from './data/covers';
import { PersonType } from './types';
/*
export const ageToGroup = (age: any) => {
  if (age < 21) return 0;
  if (age > 20 && age < 31) return 1;
  if (age > 30 && age < 35) return 2;
  if (age > 35 && age < 41) return 3;
  if (age > 40 && age < 45) return 4;
  if (age > 45 && age < 51) return 5;
  if (age > 50 && age < 56) return 6;
  if (age > 55 && age < 61) return 7;
  if (age > 60 && age < 66) return 8;
  if (age > 65 && age < 71) return 9;
  if (age > 70 && age < 76) return 10;
  if (age > 75 && age < 81) return 11;
  if (age > 80) return 12;
  return 0;
};
*/
export const ageToGroup = (age: any) => {
  if (age <= 20) return 0;
  if (age >= 21 && age <= 30) return 1;
  if (age >= 31 && age <= 35) return 2;
  if (age >= 36 && age <= 40) return 3;
  if (age >= 41 && age <= 45) return 4;
  if (age >= 46 && age <= 50) return 5;
  if (age >= 51 && age <= 55) return 6;
  if (age >= 56 && age <= 60) return 7;
  if (age >= 61 && age <= 65) return 8;
  if (age >= 66) return 9;
  return 0;
};

const initialCovers = covers.map((cover, index) => false);
export const mockPersons: PersonType[] = [
  { id: Date.now(), name: 'מבוטח', age: 24, covers: [...initialCovers] },
];

type GetInitialPerson = (index?: number) => PersonType;
export const getInitialPerson: GetInitialPerson = (index) => {
  return {
    id: Date.now(),
    name: `מבוטח ${index}`,
    age: 29,
    covers: [...initialCovers],
  };
};

export const ages: number[] = [];
for (let i = 1; i < 71; i++) {
  ages.push(i);
}

export const stringifyPersons = (persons: PersonType[]) =>
  persons
    .map(
      (person, index) =>
        `${index + 1}. שם: ${person.name}, גיל: ${
        person.age
        }, כיסויים: ${person.covers.reduce((personCovers, cover, index) => {
          if (cover) personCovers += covers[index].title + ', ';
          return personCovers;
        }, '')}, הצעת מחיר עבור מבוטח (ללא הנחה): ${person.covers
          .reduce(
            (sum, cover, index) =>
              (sum += cover ? covers[index].prices[ageToGroup(person.age)] : 0),
            0
          )
          .toFixed(2)}`
    )
    .join(' ----------- ');
